module.exports = __webpack_public_path__ + "img/logo.b5041ab0.png";